import * as React from 'react';
import { GroupSetCustom, GroupSetProps } from './index';
import { useField } from "formik";
import { GenericDropdownAsync, GenericDropdownAsyncProps } from '../controls/GenericDropdownAsync';
import { useContext } from 'react';
import { FormViewContext } from '../context/FormViewContext';


export function GroupSetDropdownAsync<T, ItemID>(props: GroupSetProps & { dropdownProps: GenericDropdownAsyncProps<T, ItemID> }) {

    const [field, meta, helpers] = useField(props.fieldName);

    const originalOnChange = props.dropdownProps.onSelectedItemChanged || props.onValueChanged;

    const formViewContext = useContext(FormViewContext);

    return (<GroupSetCustom
        title={props.title}
        fieldName={props.fieldName}
        controlSize={props.controlSize}
        required={props.required}
    >
        <GenericDropdownAsync
            {...props.dropdownProps}
            selectedValue={field.value}
            onBlur={field.onBlur}            
            onSelectedItemChanged={(item) => {

                helpers.setValue(item ? props.dropdownProps.getId(item) : undefined)

                if (originalOnChange)
                    originalOnChange(item);
            }}
            disabled={props.disabled || formViewContext.readonly == true}
        />

    </GroupSetCustom>)
}

